import { useMutation } from '@tanstack/react-query';
import toast from 'react-hot-toast';

import { startVenueBootstrap } from 'modules/shared-menu/api';

export const useBootstrapMenu = ({ onSuccess }: { onSuccess: () => void }) => {
  return useMutation((venueId: string) => startVenueBootstrap(venueId), {
    onError() {
      toast.error('Something went wrong trying to bootstrap the menu', { duration: Infinity });
    },
    onSuccess() {
      onSuccess();
      toast.success('Bootstrap in progress!');
    },
  });
};
